module.exports = __webpack_public_path__ + "static/media/gluten.c70b4e04.jpg";